import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, FileText } from "lucide-react";
import { SITE, IMAGES } from "../../data";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Hero() {
  return (
    <section id="inicio" className="relative pt-28 pb-16 lg:pt-36 lg:pb-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 mb-6 text-xs font-bold uppercase tracking-[0.2em] text-espana-red"
          >
            <span className="h-2 w-2 bg-espana-gold" />
            {SITE.origin}
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.05 }}
            className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95] text-foreground"
          >
            Reforma, eficiencia y{" "}
            <span className="text-espana-red">transparencia</span> para España.
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.12 }}
            className="mt-6 text-lg text-gray-600 max-w-xl leading-relaxed"
          >
            {SITE.tagline}
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mt-8 flex flex-wrap gap-4"
          >
            <button
              data-testid="hero-briefs-btn"
              onClick={() => scrollTo("briefs")}
              className="inline-flex items-center gap-2 bg-espana-red hover:bg-espana-reddark text-white font-bold px-6 py-3.5 rounded-sm transition-colors"
            >
              <FileText size={18} /> Ver Policy Briefs
            </button>
            <button
              data-testid="hero-carta-btn"
              onClick={() => scrollTo("carta")}
              className="inline-flex items-center gap-2 border border-gray-300 hover:bg-gray-50 text-foreground font-bold px-6 py-3.5 rounded-sm transition-colors"
            >
              Carta de Responsabilidad <ArrowRight size={18} />
            </button>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="lg:col-span-5 relative"
        >
          <div className="relative">
            <div className="absolute -top-3 -left-3 h-full w-full border-2 border-espana-gold" />
            <img
              src={IMAGES.institutional}
              alt="Fachada institucional con la bandera de España"
              className="relative w-full h-[360px] lg:h-[460px] object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 h-1.5 flex">
              <span className="flex-1 bg-espana-red" />
              <span className="flex-1 bg-espana-gold" />
              <span className="flex-1 bg-espana-red" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
